<template>
  <div class="container">
    <div v-if="list && list.length > 0">
      <div class="notification" v-for="item in list" :key="item.msgId">
        <img src="../../assets/img/mini_notification.png" alt="" />
        <!-- 右边部分 -->
        <div class="content">
          <!-- 第一行 -->
          <div class="fristLine">
            <div class="title">{{ item.eventName }}</div>
            <div class="time">{{ item.addTime }}</div>
          </div>
          <div class="lastLine">
            <!-- {{item.eventName=="审核通过"?item.messag}} -->
            <!-- {{item.message.substring(0, 4)}}{{item.message.split("》")}} -->
            <!-- {{item.message}} -->
            <span v-if="item.message.includes('已通过审核')"
              >你发布的<router-link
                target="_blank"
                :to="{ path: '/view/detail', query: { id: item.resMap?item.resMap.resId:'' } }"
                >《{{
                  item.message.split("《")[1].split("》")[0]
                }}》</router-link
              >已通过审核，文章发布到【{{
                item.message.split("【")[1].split("】")[0]
              }}
              】</span
            >

            <span v-if="item.message.includes('未通过审核')"
              >你发布的 《{{
                item.message.split("《")[1].split("》")[0]
              }}》未通过审核，快去

              <router-link   target="_blank" :to="{ path: '/user/articles', query: { id: item.userId,tab:3 } }">草稿箱</router-link>
              查看修改吧</span
            >
          </div>
        </div>
        <hr />
      </div>
      <div class="page" v-if="page.allPage && page.allPage > 1">
        <a-pagination
          v-model:current="page.currentPage"
          :total="page.allSize"
          :show-total="(total) => `共 ${page.allSize} 篇`"
          :pageSize="page.pageSize"
          show-quick-jumper
          @change="changePage"
        />
      </div>
    </div>
    <div class="img" v-else>
      <img src="../../assets/img/notification.png" alt="" />
      <span style="display: block; margin-top: 20px; font-size: 16px"
        >您还没有通知</span
      >
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, onMounted, toRefs, reactive } from "vue";
import Http from "../../until/http";
import { useRoute } from "vue-router";
import config from "../../until/configs";
export default defineComponent({
  setup() {
    const imgSiteUrl = computed(() => {
      return config.imgSiteUrl;
    });
    const route = useRoute();
    const state = reactive({
      list: [],
      page: {},
    });
    let userId = computed(() => {
      return route.query.userId;
    });

    const changePage = (e) => {
      Http.getNotification({
        msgType: 1,
        currentPage: e,
        userId: userId.value,
      }).then((res) => {
          debugger;
        if (res) {
          state.list = res.messageEntities;
          state.page = res.totalPages;
            window.scrollTo(0,0)
        }
      });
    };
    onMounted(() => {
      Http.getNotification({
        msgType: 1,
        currentPage: 1,
        userId: userId.value,
      }).then((res) => {
        if (res) {
          state.list = res.messageEntities;
          state.page = res.totalPages;
        }
      });
    });
    return {
      imgSiteUrl,
      userId,
      ...toRefs(state),
      changePage,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
.container {
  width: 1200px;
  .notification {
    overflow: hidden;
    margin-top: 15px;
    img {
      float: left;
      padding-right: 10px;
    }
    .content {
      margin-bottom: 30px;
      .fristLine {
        overflow: hidden;
        .title {
          float: left;
          color: #333;
          font-size: 16px;
        }
        .time {
          float: right;
          margin-right: 50px;
          color: #666;
          font-size: 15px;
        }
      }
      .lastLine {
        color: #666;
        font-size: 15px;
         a:hover {
          color:$primary-color;
        }
      }
    }
    hr {
      border: 0.5px solid #f0f0f0;
    }
  }
  .img {
    width: 120px;
    margin: 20% auto;
    text-align: center;
    img {
      width: 120px;
      margin-bottom: 10px;
    }
  }
  .page {
    text-align: center;
    padding-top: 40px;
     padding-bottom:20px;
  }
}
</style>